"use strict";
/* This file is autogenerated */
Object.defineProperty(exports, "__esModule", { value: true });
exports.red25Opaque = exports.red25 = exports.red20Opaque = exports.red20 = exports.red10Opaque = exports.red10 = exports.purple70Opaque = exports.purple70 = exports.purple5Opaque = exports.purple50Opaque = exports.purple50 = exports.purple5 = exports.purple40Opaque = exports.purple40 = exports.purple25Opaque = exports.purple25 = exports.purple20Opaque = exports.purple20 = exports.purple10Opaque = exports.purple10 = exports.pink70Opaque = exports.pink70 = exports.green70Opaque = exports.green70 = exports.green5Opaque = exports.green50Opaque = exports.green50 = exports.green5 = exports.green40Opaque = exports.green40 = exports.green25Opaque = exports.green25 = exports.green20Opaque = exports.green20 = exports.green10Opaque = exports.green10 = exports.blue70Opaque = exports.blue70 = exports.blue5Opaque = exports.blue50Opaque = exports.blue50 = exports.blue5 = exports.blue40Opaque = exports.blue40 = exports.blue25Opaque = exports.blue25 = exports.blue20Opaque = exports.blue20 = exports.blue10Opaque = exports.blue10 = void 0;
exports.yellow70Opaque = exports.yellow70 = exports.yellow5Opaque = exports.yellow50Opaque = exports.yellow50 = exports.yellow5 = exports.yellow40Opaque = exports.yellow40 = exports.yellow25Opaque = exports.yellow25 = exports.yellow20Opaque = exports.yellow20 = exports.yellow10Opaque = exports.yellow10 = exports.red5Opaque = exports.red50Opaque = exports.red50 = exports.red5 = exports.red40Opaque = exports.red40 = void 0;
exports.blue10 = 'rgba(90, 61, 230, 0.1)';
exports.blue10Opaque = '#EEECFD';
exports.blue20 = 'rgba(90, 61, 230, 0.2)';
exports.blue20Opaque = '#DED8FA';
exports.blue25 = 'rgba(90, 61, 230, 0.25)';
exports.blue25Opaque = '#D6CFF9';
exports.blue40 = 'rgba(90, 61, 230, 0.4)';
exports.blue40Opaque = '#BDB1F5';
exports.blue5 = 'rgba(90, 61, 230, 0.05)';
exports.blue50 = 'rgba(90, 61, 230, 0.5)';
exports.blue50Opaque = '#AD9EF3';
exports.blue5Opaque = '#F7F5FE';
exports.blue70 = 'rgba(90, 61, 230, 0.7)';
exports.blue70Opaque = '#8C77EE';
exports.green10 = 'rgba(0, 182, 131, 0.1)';
exports.green10Opaque = '#E5F8F3';
exports.green20 = 'rgba(0, 182, 131, 0.2)';
exports.green20Opaque = '#CCF0E6';
exports.green25 = 'rgba(0, 182, 131, 0.25)';
exports.green25Opaque = '#BFEDE0';
exports.green40 = 'rgba(0, 182, 131, 0.4)';
exports.green40Opaque = '#99E2CD';
exports.green5 = 'rgba(0, 182, 131, 0.05)';
exports.green50 = 'rgba(0, 182, 131, 0.5)';
exports.green50Opaque = '#80DBC1';
exports.green5Opaque = '#F2FBF9';
exports.green70 = 'rgba(0, 182, 131, 0.7)';
exports.green70Opaque = '#4DCCA8';
exports.pink70 = 'rgba(244, 97, 71, 0.7)';
exports.pink70Opaque = '#F7907E';
exports.purple10 = 'rgba(176, 57, 211, 0.1)';
exports.purple10Opaque = '#F7EBFB';
exports.purple20 = 'rgba(176, 57, 211, 0.2)';
exports.purple20Opaque = '#EFD7F6';
exports.purple25 = 'rgba(176, 57, 211, 0.25)';
exports.purple25Opaque = '#EBCEF4';
exports.purple40 = 'rgba(176, 57, 211, 0.4)';
exports.purple40Opaque = '#DFB0ED';
exports.purple5 = 'rgba(176, 57, 211, 0.05)';
exports.purple50 = 'rgba(176, 57, 211, 0.5)';
exports.purple50Opaque = '#D89CE9';
exports.purple5Opaque = '#FBF5FD';
exports.purple70 = 'rgba(176, 57, 211, 0.7)';
exports.purple70Opaque = '#C874E0';
exports.red10 = 'rgba(244, 97, 71, 0.1)';
exports.red10Opaque = '#FEEFED';
exports.red20 = 'rgba(244, 97, 71, 0.2)';
exports.red20Opaque = '#FDDFDA';
exports.red25 = 'rgba(244, 97, 71, 0.25)';
exports.red25Opaque = '#FCD8D1';
exports.red40 = 'rgba(244, 97, 71, 0.4)';
exports.red40Opaque = '#FBC0B5';
exports.red5 = 'rgba(244, 97, 71, 0.05)';
exports.red50 = 'rgba(244, 97, 71, 0.5)';
exports.red50Opaque = '#FAB0A3';
exports.red5Opaque = '#FEF7F6';
exports.yellow10 = 'rgba(255, 185, 56, 0.1)';
exports.yellow10Opaque = '#FFF8EB';
exports.yellow20 = 'rgba(255, 185, 56, 0.2)';
exports.yellow20Opaque = '#FFF1D7';
exports.yellow25 = 'rgba(255, 185, 56, 0.25)';
exports.yellow25Opaque = '#FFEECD';
exports.yellow40 = 'rgba(255, 185, 56, 0.4)';
exports.yellow40Opaque = '#FFE3AF';
exports.yellow5 = 'rgba(255, 185, 56, 0.05)';
exports.yellow50 = 'rgba(255, 185, 56, 0.5)';
exports.yellow50Opaque = '#FFDC9C';
exports.yellow5Opaque = '#FFFCF5';
exports.yellow70 = 'rgba(255, 185, 56, 0.7)';
exports.yellow70Opaque = '#FFCE74';
//# sourceMappingURL=extra-colors.js.map